<div class="content">
    <h1 showleft [showDelay]="0">Lace is Queen!</h1>
    <h2 showleft [showDelay]="100">Romantic lace tops for your softest, boldest moments.
    </h2>
    <div class="actions" showleft [showDelay]="200">
        <a matButton="filled" routerLink="/search" aria-label="Shop lace tops and dresses">Shop Lace</a>
        <a matButton="outlined" routerLink="/collection/{{newArrivalsNo}}" aria-label="New Arrivals Collection">Explore
            New Arrivals</a>
    </div>
</div>